<script>
  import dialogMixin from "./mixins/dialog";

  export default {
    mixins: [dialogMixin],
    props: {
      content: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: '課程',
        validator(value) {
          return [
            '課程',
            '活動',
          ].includes(value)
        },
      }
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogContact } isStyleDealer`"
    width="876px"
    append-to-body
  >
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">經銷商限定</div>
    <div class="text-base md:text-lg text-center">
      <p class="text-gray-6" style="line-height:2">
        此{{ text }}為經銷商會員限定報名
        <br>若有疑問，請直接與我們聯繫
      </p>
    </div>
    <BaseButton
      class="isStylePrimary isRadius isFull my-5"
      :to="{ name: 'inquiry' }"
    >
      聯絡我們
    </BaseButton>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogContact {
    padding-right: 30px;
    padding-left: 30px;

    :global {
      .sectionTitle {
        font-size: 24px;
      }

      .tel {
        &:hover, &:active {
          color: $color-primary;
          text-decoration: none;
        }
      }
    }
  }
</style>
